import { ApplicationConfig, ErrorHandler, LOCALE_ID, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { idSystemTokenInterceptor, provideIdSystem } from './core/service/id-system';
import { propInterceptor } from './core/service/api/prop.interceptor';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { GlobalErrorHandler } from './core/service/error/error-handler.service';
import { NgxMaskConfig, provideEnvironmentNgxMask } from 'ngx-mask';

const maskConfig: Partial<NgxMaskConfig> = {
  decimalMarker: ',',
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    { provide: LOCALE_ID, useValue: 'ru-RU' },
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([propInterceptor, idSystemTokenInterceptor]),
    ),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    provideEnvironmentNgxMask(maskConfig),
    ...provideIdSystem({
      ...environment.idSystem,
      tokenInterceptor: {
        urlPattern: environment.api.url
      }
    }),
  ]
}
